import styled from "styled-components/native";

import { TextInput } from "components";
import { flexStart, pickStyle as _, pickThemeKey as theme } from "utils";
import {
  ContainerWidth,
  ContainerMarginBottom,
  InputPadding,
} from "./variables";

export const Container = styled.View`
  position: relative;
  z-index: 1;
  margin: 0 auto ${_(ContainerMarginBottom) || 50}px;
  width: ${_(ContainerWidth) || "100%"};
`;

export const Label = styled.Text`
  color: ${props =>
    props.$isFocused
      ? theme("themeBlack")(props)
      : theme("themeLightGrey")(props)};
  font-size: ${props => (props.$isFocused ? "13" : "18")}px;
  position: absolute;
  top: ${props => (props.$isFocused ? "1" : "18")}px;
  ${flexStart()}: 18px;
`;

export const StyledTextInput = styled(TextInput)`
  padding: ${_(InputPadding) || "20px 18px 15px"};
  background-color: ${props =>
    props.$hasError ? theme("themeRed")(props) : theme("themeWhite")(props)};
  border-radius: 3px;
  width: 100%;
  border-bottom-width: 5px;
  border-top-width: ${({ $hasError }) => ($hasError ? 2 : 0)}px;
  border-left-width: ${({ $hasError }) => ($hasError ? 2 : 0)}px;
  border-right-width: ${({ $hasError }) => ($hasError ? 2 : 0)}px;
  border-style: solid;
  border-top-color: ${props =>
    props.$hasError ? theme("themeLightRed")(props) : "transparent"};
  border-left-color: ${props =>
    props.$hasError ? theme("themeLightRed")(props) : "transparent"};
  border-right-color: ${props =>
    props.$hasError ? theme("themeLightRed")(props) : "transparent"};
  border-bottom-color: ${props =>
    props.$hasError
      ? theme("themeLightRed")(props)
      : props.$isFocused
      ? theme("open_ended_borders")(props)
      : theme("open_ended_borders_inactive")(props)};
  font-size: ${theme("other_text_size") || 18}px;
  color: ${theme("open_ended_text")};
`;
